module.exports = __webpack_public_path__ + "img/pro-m-slider21.2675cab8.jpg";